import React, {Fragment} from 'react';
import {Col, Row} from "reactstrap";
import Fetch, {withRefresh} from "../../../Elements/Fetch";
import {
    fetchBillingCreditsList,
    fetchBillingEvents,
    fetchBillingReports,
    fetchBillingRules,
    fetchInvoices,
} from "../../../services";
import Table from "../../../Elements/Table/Table";
import {PencilIcon, PlusIcon} from "react-octicons";
import {Link} from "react-router-dom";
import Field from "../../../Elements/Field";
import BillingRulesRoute from "../../BillingRule/BillingRules/BillingRulesRoute";
import InvoicesTable from "../../Invoice/Invoices/InvoicesTable";
import BillingCreditsListRoute from "../../BillingCredits/BillingCreditsList/BillingCreditsListRoute";
import LinkToOverlay from "../../../Elements/Overlay/LinkToOverlay";
import {tableColumns as billingEventsBillableTableColumns, transformItem as billingEventsBillableTransformItem} from "../../BillingEvent/BillingEventsBillable/BillingEventsBillableTable";
import {tableColumns as billingReportsTableColumns, transformItem as billingReportsTableTransformItem} from "../../BillingReports/BillingReports/BillingReportsRoute";
import moment from "moment";

const BillingSender = ({billingSender}) => {
    return (
        <Fragment>

            <Row>
                <Col>
                    <h2 className="mb-5">
                        <span>{billingSender.name} </span>
                        <LinkToOverlay overlay={`/billing/senders/${billingSender.id}/edit`}>
                            <PencilIcon/>
                        </LinkToOverlay>
                    </h2>
                </Col>
            </Row>

            <Row>
                <Col>
                    <Field name='Billable from'>{new Date(billingSender.billableFrom).toLocaleDateString()}</Field>
                    <Field name='Billable types prepaid'>{billingSender.prepaidBillingEventTypes.join(", ")}</Field>
                    <Field
                        name='Billable subtypes prepaid'>{billingSender.prepaidBillingEventSubtypes.join(", ")}</Field>
                    <Field name='Billable types postpaid'>{billingSender.billingEventTypes.join(", ")}</Field>
                    <Field name='Billable subtypes postpaid'>{billingSender.billingEventSubtypes.join(", ")}</Field>
                    <Field
                        name='Billable types monthly plan'>{billingSender.monthlyPlanBillingEventTypes.join(", ")}</Field>
                    <Field
                        name='Billable subtypes monthly plan'>{billingSender.monthlyPlanBillingEventSubtypes.join(", ")}</Field>
                    <Field name='PO number'>{billingSender.poNumber}</Field>
                    <Field name='Senders'>
                        {billingSender.senders.length > 0 && (
                            <ul>
                            {
                                billingSender.senders.map((sender) => (
                                    <li key={sender.id}>
                                        <Link to={'/senders/' + sender.id}>{sender.id}: {sender.name} ({sender.senderContractNumber})</Link>
                                    </li>
                                ))
                            }
                            </ul>
                        )}
                    </Field>
                </Col>
                <Col>
                    <Field name='Portal logo'>{billingSender.portalLogo}</Field>
                    <Field name='Contract POM'>{billingSender.typeContractPOM}</Field>
                    <Field name='SLA getekend'>{billingSender.slaSigned}</Field>
                    <Field name='Data processing agreement'>{billingSender.dataProcessingAgreement}</Field>
                    <Field name='Billing frequency'>{billingSender.billingFrequency}</Field>
                </Col>
            </Row>

            <Row>
                <Col>
                    <Fetch fetchFunction={fetchBillingEvents}
                           fetchFunctionParams={{'billingSender.id': billingSender.id}}>
                        {(events) => (
                            <Table
                                extraClassName='table-sm'
                                name="Unbilled events"
                                columns={billingEventsBillableTableColumns(['billingSenderFormatted'])}
                                items={events.items.map(billingEventsBillableTransformItem)}
                            />
                        )}
                    </Fetch>
                </Col>
                <Col>
                    <Fetch fetchFunction={fetchBillingRules}
                           fetchFunctionParams={{'billingSender.id': billingSender.id}}
                           refreshKey="billingRules">
                        {(rules) => (
                            <Table
                                extraClassName='table-sm'
                                name="Billing rules"
                                columns={BillingRulesRoute.tableColumns(['billingSender'], false)}
                                items={rules.items.map(item => BillingRulesRoute.transformItem(item))}
                            />
                        )}
                    </Fetch>
                </Col>
            </Row>

            <Row>
                <Col>
                    <Fetch fetchFunction={fetchInvoices} fetchFunctionParams={{'billingSender.id': billingSender.id}}
                           refreshKey="invoices">
                        {(invoices) => (
                            <Table
                                extraClassName='table-sm'
                                name="Invoices"
                                columns={InvoicesTable.tableColumns(['billingSender', 'pllayUser'], false)}
                                items={invoices.items.map(item => InvoicesTable.transformItem(item))}
                            />
                        )}
                    </Fetch>
                </Col>
                <Col>
                    <Fetch fetchFunction={fetchBillingCreditsList} fetchFunctionParams={{id: billingSender.id}}
                           refreshKey="billingCreditsList">
                        {(credits) => (
                            <Table
                                extraClassName='table-sm'
                                name="Billing credits"
                                columns={BillingCreditsListRoute.tableColumns(['billingSender'], false)}
                                items={credits.items.map(item => BillingCreditsListRoute.transformItem(item))}
                            />
                        )}
                    </Fetch>
                </Col>
            </Row>

            <Row>
                <Col>
                    <Fetch fetchFunction={fetchBillingReports}
                           fetchFunctionParams={{'billingSender.id': billingSender.id}}
                           refreshKey="billingReports">
                        {(billingReports) => (
                            <Table
                                extraClassName='table-sm'
                                name="Reports"
                                columns={billingReportsTableColumns(['billingSenderName'], false)}
                                items={billingReports.items.map(billingReportsTableTransformItem)}
                            />
                        )}
                    </Fetch>
                </Col>
                <Col>
                    <Table
                        name={(
                            <>
                                <span>Contacts: </span>
                                <LinkToOverlay overlay={`/billing/senders/${billingSender.id}/contact/add`}>
                                    <PlusIcon/>
                                </LinkToOverlay>
                            </>
                        )}
                        hideLabelColon
                        columns={{
                            email: 'E-mail',
                            fullName: 'Name',
                            language: 'Language',
                            getBillingReport: 'Billing report',
                            edit: 'Edit',
                        }}
                        items={billingSender.billingContacts.map(billingContact => ({
                            ...billingContact,
                            key: billingContact.id,
                            fullName: `${billingContact.firstName} ${billingContact.lastName}`,
                            getBillingReport: billingContact.getBillingReport ? 'Yes' : 'No',
                            edit: (
                                <LinkToOverlay
                                    overlay={`/billing/senders/${billingSender.id}/contact/${billingContact.id}/edit`}>
                                    <PencilIcon/>
                                </LinkToOverlay>
                            ),
                        }))}
                        extraClassName='table-sm'
                        autoWidthColumns={['email', 'fullName', 'language', 'getBillingReport', 'edit']}
                    />
                </Col>
            </Row>

            <Row>
                <Col>
                    <Table
                        extraClassName='table-sm'
                        name="History"
                        columns={{
                            dateCreated: 'Date',
                            userName: 'User',
                            fieldName: 'Field',
                            previousValue: 'From',
                            newValue: 'To',
                        }}
                        items={billingSender.history.map(item => ({
                            ...item,
                            key: item.id,
                            dateCreated: moment(item.dateCreated).format('DD/MM/YYYY HH:mm:ss'),
                        }))}
                    />
                </Col>
            </Row>

        </Fragment>
    );
};

export default withRefresh(BillingSender);

